export type UserFormState = {
    username: string;
    password: string;
    role: string;
    repeatPassword: string;
    email?: string | null;
    truck?: string | null;
    userList?: userDataList[] | null;
    selectedUser?: boolean;
    status?: number | null;
    user_id?: number;
};

export type userDataList = {
    user_id: number;
    username: string;
    password: string;
    role: string;
    role_id: string;
    email?: string;
    truck?: string;
    status: number;
    create_date: string;
    update_date: string;
};

export const userFormState: UserFormState = {
    username: "",
    password: "",
    role: "",
    repeatPassword: "",
    status: null,
    userList: null,
    selectedUser: false,
};
